import type { Response } from '@swf/core/types/Account';

export const handleEffectResponse = (response: Response) => {
  const { errors, message } = response;

  const setGlobalError = () => {
    if (errors?.globalErrors?.length) {
      return errors?.globalErrors;
    }
    if (errors?.code) {
      return [{ code: errors?.code }];
    }
    if (message) {
      return [{ defaultMessage: message }];
    }
    return undefined;
  };

  if (response.success) {
    return response;
  } else {
    return Promise.reject({
      body: {
        globalErrors: setGlobalError(),
        fieldErrors: errors?.fieldErrors?.length ? errors?.fieldErrors : undefined
      }
    });
  }
};
